import React from 'react';
//import { withRouter } from 'react-router';

import MenuMarkup from './landingheader';
import ResponsiveNav from './ResponsiveNav';

const HeaderContainer = () => {
  return (
    <ResponsiveNav
      menuMarkup={MenuMarkup}
      placement='bottomLeft'
    />
  );
};

export default HeaderContainer;